var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { observable, computed, action, reaction, runInAction } from 'mobx';
import http, { Q, Api } from '@http';
import moment from 'moment';
import { isArray, isString, lowerCase, take } from "lodash-es";
import { getTimeOfSlotRank, getIsRecommendationSlot } from '@common/utils';
import { ClientUserTrackingCode } from '@common/enums/base';
var ProjectProcareStatus = {
    Completed: 4,
    Canceled: 5,
    Scheduled: 8,
    Unscheduled: 20
};
var RescheduleStore = /** @class */ (function () {
    function RescheduleStore(rootStore) {
        var _this = this;
        this.fetchingState = {
            getProCareDetail: false,
            getCanChangeTechnician: false,
            getScheduleTime: false,
            getWeather: false,
            firstLoadComplete: false,
            loadingScheduleTime: false,
            saving: false,
            getProjectWorkOrderList: false
        };
        this.formData = {
            scheduleStartTime: null,
            scheduleEndTime: null
        };
        this.canChangeTechnician = false;
        this.modalVisible = false;
        this.weatherForecastByTime = [];
        this.scheduleTime = [];
        this.setModalVisible = function (visible) {
            _this.modalVisible = visible;
        };
        this.selectPeroid = function (data) {
            _this.selectedScheduleTime = data;
        };
        this.changeScheduleStartTime = function (value) {
            _this.formData.scheduleStartTime = value;
        };
        this.changeScheduleEndTime = function (value) {
            _this.formData.scheduleEndTime = value;
        };
        this.saveSchedule = function () {
            if (!_this.canSave) {
                return new Promise(function () { });
            }
            runInAction(function () {
                _this.fetchingState.saving = true;
            });
            return _this.save();
        };
        this.api = {
            canChangeTechnician: function (procareId) {
                return Q(http.get("/RSP/ProCare/" + procareId + "/CanChangeTechnician"));
            },
            rspGetWeatherForecastByTime: function (formData) {
                return Q(http.post("/RSP/NewRequest/GetWeatherForecastByTime", formData, Api.withForm));
            },
            rspGetRescheduleProCareByServiceCodeRecommendTechnicians: function (params) {
                return Q(http.post("/VisitAutoSchedule/GetRescheduleProCareByServiceCodeRecommendTechnicians", params, Api.withForm));
            },
            visitCreateSubTask: function (params) {
                return Q(http.post("/RSP/ProCare/CreateSubTask", params));
            },
        };
        this.initReactions();
        this.rootStore = rootStore;
    }
    RescheduleStore.prototype.initReactions = function () {
        var _this = this;
        var reactionFn = function () { return ({
            ready: _this.fetchingState.getCanChangeTechnician &&
                _this.formData.scheduleStartTime &&
                _this.canChangeTechnician &&
                _this.modalVisible,
            scheduleStartTime: _this.formData.scheduleStartTime
        }); };
        var callback = function (result) {
            var ready = result.ready, scheduleStartTime = result.scheduleStartTime;
            if (ready) {
                console.log('RescheduleStore callback');
                _this.selectedScheduleTime = null;
                _this.getScheduleTime(scheduleStartTime);
            }
        };
        reaction(reactionFn, callback, { delay: 30 });
    };
    RescheduleStore.prototype.getDueRange = function (rangeLeftOrRight) {
        // 24h * 60min * 60s * 30d * 1000ms * 2month
        var left60DaysOffset = -5184000000;
        // 24h * 60min * 60s * 30d * 1000ms  
        var right30DaysOffset = 2592000000;
        // getTimezoneOffset * 60s * 1000ms
        var offset = rangeLeftOrRight ? left60DaysOffset : right30DaysOffset;
        var timeStampOffset = new Date().getTimezoneOffset() * 60000 + offset;
        return moment(moment(this.rootStore.procareDetail.DueDate).valueOf() + timeStampOffset);
    };
    RescheduleStore.prototype.visitFormartRawAutoSchedule = function (rawData) {
        if (!(rawData && rawData.pullInRecommend)) {
            return [];
        }
        var pullInRecommend = rawData.pullInRecommend;
        pullInRecommend.topRecommends.forEach(function (x) { x.isRecommend = true; });
        pullInRecommend.recommends.forEach(function (x) { x.isRecommend = false; });
        var scheduleTimeList = __spreadArrays(pullInRecommend.topRecommends, pullInRecommend.recommends);
        return scheduleTimeList.map(function (x) {
            return {
                id: Symbol(),
                scheduleStartTime: x.scheduleStartTime,
                scheduleEndTime: x.scheduleEndTime,
                canSelect: x.canSelect,
                isRecommend: x.isRecommend,
                _rank: x.indexOf,
                BundleWoIds: null,
                technicianId: null,
                _sumArr: null,
                _weather: null,
                _selected: false,
                affiliateId: x.affiliateId,
                technicianScores: x.technicianScores,
                visitId: x.visitId
            };
        });
    };
    RescheduleStore.prototype.getYYMMDD = function (momentObj) {
        return momentObj.utc().format("YYYY-MM-DD");
    };
    Object.defineProperty(RescheduleStore.prototype, "dueRangeLeft", {
        get: function () {
            var rangeLeft = true;
            return this.rootStore.procareDetail ? this.getDueRange(rangeLeft) : moment();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RescheduleStore.prototype, "dueRangeRight", {
        get: function () {
            var rangeRight = false;
            return this.rootStore.procareDetail ? this.getDueRange(rangeRight) : moment();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RescheduleStore.prototype, "showReschedule", {
        get: function () {
            return this.rootStore.procareDetail ? this.rootStore.procareDetail.StatusId === ProjectProcareStatus.Scheduled : false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RescheduleStore.prototype, "canSave", {
        get: function () {
            return this.selectedScheduleTime !== null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RescheduleStore.prototype, "procareDueDate", {
        get: function () {
            if (this.rootStore.procareDetail) {
                return moment(this.rootStore.procareDetail.DueDate)
                    .utc()
                    .format("MM/DD/YYYY");
            }
            return "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RescheduleStore.prototype, "topItems", {
        get: function () {
            var _this = this;
            var items = this.scheduleTime;
            items.forEach(function (element) {
                var dateStr = _this.getYYMMDD(moment(element.scheduleStartTime));
                var weather = _this.weatherForecastByTime.find(function (weather) {
                    var weatherDateStr = _this.getYYMMDD(moment(weather.date));
                    return weatherDateStr === dateStr;
                });
                element._weather = weather;
                element._selected = _this.selectedScheduleTime && element.id === _this.selectedScheduleTime.id;
            });
            return take(items, 7);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RescheduleStore.prototype, "noScheduleTime", {
        get: function () {
            return (this.fetchingState.firstLoadComplete &&
                (this.topItems.length === 0 || this.topItems.every(function (time) { return !time.canSelect; })));
        },
        enumerable: false,
        configurable: true
    });
    RescheduleStore.prototype.getCanChangeTechnician = function (procareId) {
        return __awaiter(this, void 0, void 0, function () {
            var canData;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.fetchingState.getCanChangeTechnician = false;
                        return [4 /*yield*/, this.api.canChangeTechnician(procareId)];
                    case 1:
                        canData = _a.sent();
                        runInAction(function () {
                            if (typeof canData === "boolean") {
                                _this.canChangeTechnician = canData;
                            }
                            else if (isString(canData)) {
                                _this.canChangeTechnician = lowerCase(canData) === "true";
                            }
                            _this.fetchingState.getCanChangeTechnician = true;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    RescheduleStore.prototype.getScheduleTime = function (scheduleStartTime) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                if (!this.fetchingState.getWeather) {
                    this.getWeatherForecastByTime();
                }
                this.fetchingState.getScheduleTime = false;
                this.fetchingState.loadingScheduleTime = true;
                params = {
                    procareId: this.rootStore.procareDetail.Id,
                    serviceCodeId: this.rootStore.stepStore.serviceCode,
                    startTime: moment(scheduleStartTime).format("YYYY-MM-DD HH:mm:ss"),
                    canScheduleInWeekend: false,
                };
                this.getVisitAutoScheduleData(params);
                return [2 /*return*/];
            });
        });
    };
    RescheduleStore.prototype.getVisitAutoScheduleData = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var scheduleTimeData;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.rspGetRescheduleProCareByServiceCodeRecommendTechnicians(params)];
                    case 1:
                        scheduleTimeData = _a.sent();
                        runInAction(function () {
                            _this.fetchingState.firstLoadComplete = true;
                            _this.fetchingState.getScheduleTime = true;
                            _this.fetchingState.loadingScheduleTime = false;
                            if (!scheduleTimeData) {
                                _this.scheduleTime = [];
                            }
                            else {
                                _this.scheduleTime = _this.visitFormartRawAutoSchedule(scheduleTimeData);
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    RescheduleStore.prototype.getWeatherForecastByTime = function () {
        return __awaiter(this, void 0, void 0, function () {
            var formData, i, weatherData;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.fetchingState.getWeather = false;
                        formData = {
                            locationId: this.rootStore.procareDetail.Location.Id,
                            times: []
                        };
                        for (i = -1; i < 16; i += 1) {
                            formData.times.push(moment().utc()
                                .add(i, "days")
                                .format("YYYY-MM-DD"));
                        }
                        return [4 /*yield*/, this.api.rspGetWeatherForecastByTime(formData)];
                    case 1:
                        weatherData = _a.sent();
                        runInAction(function () {
                            _this.fetchingState.getWeather = true;
                            if (isArray(weatherData)) {
                                _this.weatherForecastByTime = weatherData;
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    RescheduleStore.prototype.save = function () {
        var selectedScheduleTime = this.selectedScheduleTime;
        var autoScheduleModel = {
            projectId: this.rootStore.procareDetail.Id,
            scheduleStartTime: selectedScheduleTime.scheduleStartTime,
            scheduleEndTime: selectedScheduleTime.scheduleEndTime,
            affiliateId: selectedScheduleTime.affiliateId,
            technicianScores: selectedScheduleTime.technicianScores,
            visitId: selectedScheduleTime.visitId,
            rank: selectedScheduleTime._rank,
        };
        console.log(selectedScheduleTime);
        var timeOfSlotRank = getTimeOfSlotRank([selectedScheduleTime]);
        var isRecommendationSlot = getIsRecommendationSlot([selectedScheduleTime]);
        return this.sendParamsCreateSubtask(autoScheduleModel, timeOfSlotRank, isRecommendationSlot);
    };
    RescheduleStore.prototype.sendParamsCreateSubtask = function (autoscheduleModel, timeofSlotRank, isRecommendationSlot) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var _a, LocationId, Id, Client, StatusId, logData, code;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.api.visitCreateSubTask({
                            scheduleResult: __assign(__assign({}, autoscheduleModel), { procareId: this.rootStore.procareDetail.Id, projectTypeId: this.rootStore.procareDetail.ProjectTypeId, version: this.rootStore.procareDetail.Version, locationId: this.rootStore.procareDetail.Location.Id, scheduleStartTime: this.selectedScheduleTime.scheduleStartTime, scheduleEndTime: this.selectedScheduleTime.scheduleEndTime, isReschedule: this.showReschedule }),
                            serviceCodeId: this.rootStore.stepStore.serviceCode,
                            additionalDetail: this.rootStore.stepStore.additionalDetail,
                            attachments: this.rootStore.stepStore.attachments
                        })];
                    case 1:
                        _b.sent();
                        this.setModalVisible(false);
                        runInAction(function () {
                            _this.fetchingState.saving = false;
                        });
                        _a = this.rootStore.procareDetail, LocationId = _a.LocationId, Id = _a.Id, Client = _a.Client, StatusId = _a.StatusId;
                        logData = {
                            isRecommendationSlot: isRecommendationSlot,
                            locationId: LocationId,
                            ProjectID: Id,
                            ProCareStatusId: StatusId,
                            clientId: Client.Id,
                            TimeofSlot_Rank: timeofSlotRank
                        };
                        code = ClientUserTrackingCode.RspProCareReschedule;
                        resolve({ code: code, logData: logData });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    __decorate([
        observable
    ], RescheduleStore.prototype, "fetchingState", void 0);
    __decorate([
        observable
    ], RescheduleStore.prototype, "formData", void 0);
    __decorate([
        observable
    ], RescheduleStore.prototype, "canChangeTechnician", void 0);
    __decorate([
        observable
    ], RescheduleStore.prototype, "modalVisible", void 0);
    __decorate([
        observable
    ], RescheduleStore.prototype, "selectedScheduleTime", void 0);
    __decorate([
        observable
    ], RescheduleStore.prototype, "weatherForecastByTime", void 0);
    __decorate([
        observable
    ], RescheduleStore.prototype, "scheduleTime", void 0);
    __decorate([
        computed
    ], RescheduleStore.prototype, "dueRangeLeft", null);
    __decorate([
        computed
    ], RescheduleStore.prototype, "dueRangeRight", null);
    __decorate([
        computed
    ], RescheduleStore.prototype, "showReschedule", null);
    __decorate([
        computed
    ], RescheduleStore.prototype, "canSave", null);
    __decorate([
        computed
    ], RescheduleStore.prototype, "procareDueDate", null);
    __decorate([
        computed
    ], RescheduleStore.prototype, "topItems", null);
    __decorate([
        computed
    ], RescheduleStore.prototype, "noScheduleTime", null);
    __decorate([
        action
    ], RescheduleStore.prototype, "setModalVisible", void 0);
    __decorate([
        action
    ], RescheduleStore.prototype, "getCanChangeTechnician", null);
    __decorate([
        action
    ], RescheduleStore.prototype, "getScheduleTime", null);
    __decorate([
        action
    ], RescheduleStore.prototype, "getVisitAutoScheduleData", null);
    __decorate([
        action
    ], RescheduleStore.prototype, "getWeatherForecastByTime", null);
    __decorate([
        action
    ], RescheduleStore.prototype, "selectPeroid", void 0);
    __decorate([
        action
    ], RescheduleStore.prototype, "changeScheduleStartTime", void 0);
    __decorate([
        action
    ], RescheduleStore.prototype, "changeScheduleEndTime", void 0);
    return RescheduleStore;
}());
export default RescheduleStore;
